export const verificarValor = (parametro: any): string => {
  if (typeof parametro === 'object' && Object.keys(parametro).length === 0) {
    return '';
  }
  if (typeof parametro === 'string' && parametro.trim() === '') {
    return '';
  }
  return parametro;
};
